import React from 'react';
import ApiActions from 'go/actions/api';
import {connect} from 'react-redux';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {ContentDispatch} from 'framework';
import {Contexts} from 'componentLibrary';
import {Dimmer, Loader} from 'semantic-ui-react';
import {ACTIVITY_RESPONSES} from 'app-ui-componentlibrary/dist/common/constants';
import {
  API_TASK_COMPLETE_SUCCESS,
  API_CONTEXT_GET_SUCCESS,
  SNAPSHOT_POST_SUCCESS,
  API_CONFIG_GET_SUCCESS,
  DYNAMIC_DATA_GET_ENTITY_SUCCESS,
  DYNAMIC_DATA_POST_SUCCESS,
} from 'common/types';
import {Redirect} from 'react-router-dom';
import _ from 'lodash';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import {
  checkActivityCompleted,
  compileContent,
  countDependenciesToLoad,
  isFemaUser,
} from 'common/utils';
import {ADD_MSG} from 'common/types';
import NetworkErrorModal from 'go/components/dynamic/common/modals/NetworkErrorModal';
const {SubmitContext} = Contexts;
import {HOME} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {EXCLUDEDFOS} from 'common/requestDetails/constants.js';

export class TaskPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      submitting: false,
      error: false,
      reviewType: '',
      reviewTypeName: '',
      redirect: false,
      initialized: false,
    };
  }

  initializeComponent = () => {
    let hash = this.props.hash;
    if (hash) {
      hash = hash.replace(/[&\/\\#,+()$~%.'":*?<>{}0-9]/g, ' ');
      // On Application, when clicking children items under Grant request details
      // the hash used for the page title looks like #item-1-children-uuid-string
      // Here if the hash contains 'children', we'll assign the page title in
      // RequestDetailsSideNav.js child menu item in the <Menu.Item onClick
      if (hash.indexOf('children') === -1) {
        document.title = `${HOME} - ${hash}`;
      }
    }
    let {getContext, token, taskId, postDynamicData} = this.props;
    getContext(token, taskId)
      .then((res) => {
        if (res && res.type === API_CONTEXT_GET_SUCCESS) {
          let {
            process,
            fundingOpportunityId,
            reviewType,
            grantId,
            programId,
            organizationId,
            entityId,
            contextId,
            contextType,
            subGrantId,
          } = res.payload.processVariables;
          let {name, taskDefinitionKey} = res.payload.task;
          reviewType = reviewType ? reviewType : taskDefinitionKey;
          let contextTypeparam = 'fo';
          let contextIdparam = fundingOpportunityId;
          if (contextType === 'pc') {
            contextIdparam = contextId;
            contextTypeparam = 'pc';
          }

          this.setState({
            fundingOpportunityId: fundingOpportunityId,
            grantId: grantId,
            organizationId: organizationId,
            process: process,
            programId: programId,
            reviewType: reviewType,
            reviewTypeName: name,
          });

          {
            return this.fetchConfigAndData(
              token,
              contextTypeparam,
              contextIdparam,
              reviewType,
              taskId,
              subGrantId,
              res.payload.processVariables
            );
          }
        }
      })
      .then((res) => {
        if (
          res &&
          [DYNAMIC_DATA_GET_ENTITY_SUCCESS, DYNAMIC_DATA_POST_SUCCESS].includes(res.type)
        ) {
          this.initializeReduxState(
            this.state.config,
            {...res.payload, taskId},
            postDynamicData
          );
        } else {
          this.setState({error: true});
        }
      })
      .catch((err) => {
        console.error('err');
        this.setState({
          error: true,
        });
      });
  };

  componentDidMount() {
    this.initializeComponent();
  }

  componentDidUpdate() {
    if (this.props.reloadTask) {
      this.props.saveEntitySessionData('reloadTask', false, null);
      this.setState(
        {
          loading: true,
          initialized: false,
        },
        this.initializeComponent
      );
    }
  }

  handlePostSubmit = () => {
    const {config} = this.props;
    this.props.addMessage(compileContent(_.get(config, 'rerouteMessage'), this.props));
  };

  fetchConfigAndData = (
    token,
    configEntityType,
    fundingOpportunityId,
    entityType,
    entityId,
    subGrantId,
    processVariables
  ) => {
    const {getConfig, getDynamicDataByEntityId, postDynamicData} = this.props;
    let configType = 'taskDefinition';

    let taskConfigId = _.get(processVariables, 'taskConfigId', entityType);

    return getConfig(
      token,
      configEntityType,
      fundingOpportunityId,
      configType,
      taskConfigId
    ).then((res) => {
      if (res && res.type === API_CONFIG_GET_SUCCESS) {
        this.setState({config: res.payload});
        const additionalPayloadConfig = _.get(res, 'payload.payload.additionalPayload');
        return getDynamicDataByEntityId(token, entityId).then((res) => {
          if (res && res.type === DYNAMIC_DATA_GET_ENTITY_SUCCESS) {
            if (_.isEmpty(res.payload)) {
              let payloadExtension = {};
              if (additionalPayloadConfig) {
                const items = _.keys(additionalPayloadConfig);
                _.forEach(items, (item) => {
                  payloadExtension[item] = _.get(
                    processVariables,
                    additionalPayloadConfig[item],
                    additionalPayloadConfig[item]
                  );
                });
              }
              const payload = {
                entityId: entityId,
                grantId: this.state.grantId,
                organizationId: this.state.organizationId,
                programId: this.state.programId,
                entityType: this.state.reviewType,
                subGrantId: subGrantId,
                ...payloadExtension,
                payload: {},
              };
              if (this.state.fundingOpportunityId) {
                payload.fundingOpportunityId = +this.state.fundingOpportunityId;
              }
              return postDynamicData(payload, token);
            } else {
              return res;
            }
          }
        });
      }
    });
  };

  initializeReduxState = (config, data, saveFunction) => {
    const {auth, toggles, profile} = this.props;

    const serviceCall = {
      apiCall: saveFunction,
      args: {
        reviewType: this.state.reviewType,
      },
    };

    const dynamicComponentInitialStateToMerge = {
      config,
      data,
      context: {
        auth,
        toggles,
        profile,
      },
      validations: {},
      serviceCall,
    };

    this.props.init(dynamicComponentInitialStateToMerge);
    this.setState({initialized: true});
  };

  handleErrorConfirmation = () => {
    this.props.history.push('/redirecting_page');
    this.props.clear().then(() => {
      this.props.history.replace(this.props.routerLocation);
    });
  };

  handleSubmit = (configTaskPayload, password) => {
    let {
      completeTask,
      dynamicComponent,
      postSnapshot,
      taskId,
      token,
      config,
    } = this.props;
    const activityToWaitFor = _.get(
      this.props,
      'dynamicComponent.config.payload.activityToWaitFor',
      _.get(
        this.props,
        _.get(this.props, 'dynamicComponent.config.payload.activityToWaitForPath')
      )
    );
    const checkTaskVal = _.get(config, 'payload.checkTaskVal', false);
    this.setState({submitting: true});
    let data = {..._.get(dynamicComponent, 'data', {})};
    let context = _.get(dynamicComponent, 'context', {});

    if (!data.id) {
      data.id = data.entityId;
    }

    return postSnapshot(data, token)
      .then((res) => {
        if (res && res.type === SNAPSHOT_POST_SUCCESS) {
          const finalReviewPath = _.get(config, 'payload.finalReviewPath', '');
          // TODO, change configs to have these be the same "finalReview" in all tasks
          const finalReview =
            _.get(data.payload, 'reviewPanel.finalReview') ||
            _.get(data.payload, 'finalFinancialReview') ||
            _.get(context, finalReviewPath);
          const baseTaskPayload = {};
          baseTaskPayload.task = this.state.reviewTypeName;
          baseTaskPayload.process = this.state.process;

          if (finalReview !== undefined) {
            baseTaskPayload.internalComment = finalReview.comments;
            baseTaskPayload.externalComment = finalReview.commentsForRecipient;
          }

          // this is currently redundant, but maybe the subject won't be the outcome one day
          // probably better to keep them seperate keys when looking on the backend
          baseTaskPayload.subject = configTaskPayload.outcome;
          baseTaskPayload.grantId = _.get(
            data,
            'grantId',
            _.get(context, 'grant.grantId')
          );
          baseTaskPayload.organizationId = data.organizationId;
          baseTaskPayload.author = this.props.author;
          baseTaskPayload.userId = this.props.userId;
          baseTaskPayload.awardRecommendationId = _.get(
            context,
            'awardRecommendation.entityId'
          );
          baseTaskPayload.subAwardRecommendationId = _.get(
            context,
            'subAwardRecommendation.entityId'
          );

          if (data.programId) {
            baseTaskPayload.programId = +data.programId;
          }

          const taskPayloadToSubmit = {
            ...baseTaskPayload,
            ...configTaskPayload,
          };

          return completeTask(taskId, taskPayloadToSubmit, token, password);
        }
      })
      .then((res) => {
        if (res && res.type === API_TASK_COMPLETE_SUCCESS) {
          if (activityToWaitFor) {
            return checkActivityCompleted({
              token: token,
              processInstanceId: this.props.processInstanceId,
              activityId: activityToWaitFor,
              checkTaskVal: checkTaskVal,
              activityResponse: ACTIVITY_RESPONSES.ended,
              callback: () => {
                this.setState({redirect: true});
                return res;
              },
            });
          } else {
            this.setState({redirect: true});
            return res;
          }
        } else {
          if (_.get(res, 'meta.status') === 403) {
            this.setState({submitting: false});
            res.status = res.meta.status;
            return res;
          } else {
            this.setState({submitting: false, error: true});
            return res;
          }
        }
      });
  };
  static getDerivedStateFromProps(props, state) {
    const toggles = _.get(props, 'toggles.toggles');
    const externalSSPShield = _.includes(toggles, 'externalSSPShield');

    if (
      externalSSPShield &&
      !isFemaUser(_.get(props, 'auth.permissions')) &&
      _.includes(EXCLUDEDFOS, Number(_.get(state, 'fundingOpportunityId')))
    ) {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }

    const dependencies = _.get(
      props,
      'dynamicComponent.config.payload.dependencies',
      _.get(props, 'dynamicComponent.config.dependencies')
    );

    const dependenciesToLoad = countDependenciesToLoad(
      dependencies,
      isFemaUser(_.get(state, 'auth.permissions')),
      toggles,
      // TODO: Put entity type + entity id
      'fundingOpportunityId',
      _.get(state, 'fundingOpportunityId')
    );
    if (
      state.initialized &&
      state.loading &&
      _.get(props, 'dynamicComponent.context.numLoadedSuccessfully') ===
        dependenciesToLoad
    ) {
      return {
        ...state,
        loading: false,
      };
    }
    return null;
  }

  render() {
    let {dynamicComponent, taskContext, saveDataBasedTitles} = this.props;
    let {currentLocation, config} = dynamicComponent;
    let location = currentLocation === '' ? 'contents[0]' : currentLocation;
    const {rerouteOnSubmit} = config;

    let {error, redirect, loading, reviewType, submitting} = this.state;

    const submitContext = {
      handleSubmit: this.handleSubmit,
      handlePostSubmit: this.handlePostSubmit,
    };

    if (error) {
      return <Error />;
    } else if (redirect) {
      return (
        <React.Fragment>
          <Redirect
            to={rerouteOnSubmit ? compileContent(rerouteOnSubmit, this.props) : `/tasks/`}
            push
          />
        </React.Fragment>
      );
    } else if (loading) {
      return <Loader active>Loading...</Loader>;
    } else {
      return (
        <React.Fragment>
          <NetworkErrorModal
            networkErrorPath="saveEntitySaga"
            handleErrorConfirmation={this.handleErrorConfirmation}
          />
          {submitting && (
            <Dimmer active>
              <Loader />
            </Dimmer>
          )}
          <SubmitContext.Provider value={submitContext}>
            {config.payload && (
              <ContentDispatch
                config={config.payload}
                currentLocation={location}
                dynamicComponent={dynamicComponent}
                reviewType={reviewType}
                handleSubmit={this.handleSubmit}
                loading={loading}
                taskContext={taskContext}
                saveDataBasedTitles={saveDataBasedTitles}
              />
            )}
          </SubmitContext.Provider>
        </React.Fragment>
      );
    }
  }
}

export const mapDispatchToProps = (dispatch) => ({
  init: (initState) => dispatch(DynamicComponentActions.initWithState(initState)),
  clear: () => {
    return new Promise((resolve, reject) => {
      dispatch(DynamicComponentActions.clearDynamicComponent({}));
      resolve();
    });
  },
  getContext: (token, id) => {
    let action = ApiActions.tasks.getContext(token, id);
    const res = dispatch(action);
    return res;
  },
  completeTask: (id, payload, token, password) => {
    const action = ApiActions.tasks.completeTask(
      id,
      JSON.stringify(payload),
      token,
      password
    );
    const res = dispatch(action);
    return res;
  },
  postSnapshot: (payload, token) => {
    const action = ApiActions.snapshot.postSnapshot(token, payload);
    const response = dispatch(action);
    return response;
  },
  getConfig: (token, entityType, entityId, configType, configId) => {
    let action = ApiActions.config.getConfig(
      token,
      entityType,
      entityId,
      configType,
      configId
    );
    const res = dispatch(action);
    return res;
  },
  getDynamicDataByEntityId: (token, entityId) => {
    let action = ApiActions.dynamicData.getDataByEntityId(token, entityId);
    const res = dispatch(action);
    return res;
  },
  postDynamicData: (payload, token) => {
    const data = payload.data ? payload.data : payload;
    const dataPayload = JSON.stringify(_.omit(data, ['version']));
    let action = ApiActions.dynamicData.postData(token, dataPayload);
    const res = dispatch(action);
    return res;
  },
  saveDataBasedTitles: (dataBasedTitles) =>
    dispatch(DynamicComponentActions.saveDataBasedTitles(dataBasedTitles)),
  saveEntitySessionData: (dataPath, data, fieldName) =>
    dispatch(
      DynamicComponentActions.saveEntitySessionData(dataPath, data, fieldName, false)
    ),

  addMessage: addMessage(dispatch),
});

export const mapStateToProps = (state) => {
  const author = state.auth.firstName + ' ' + state.auth.lastName;
  return {
    auth: state.auth,
    author: author,
    config: _.get(state, 'dynamicComponent.config'),
    dynamicComponent: state.dynamicComponent,
    routerLocation: _.get(state, 'router.location.pathname'),
    grantId: _.get(
      state,
      'dynamicComponent.context.workflowTask.processVariables.grantId'
    ),
    processInstanceId: _.get(
      state,
      'dynamicComponent.context.workflowTask.task.processInstanceId'
    ),
    profile: state.profile,
    reloadTask: state.dynamicComponent.reloadTask,
    taskContext: state.dynamicComponent.context.workflowTask,
    taskId: state.router.location.pathname.split('/').pop(),
    toggles: state.toggles,
    token: state.auth.token,
    userId: state.auth.userId,
    hash: state.router.location.hash,
  };
};

const addMessage = (dispatch) => {
  return (msg) =>
    dispatch({
      type: ADD_MSG,
      msg: msg,
    });
};

export default connect(mapStateToProps, mapDispatchToProps)(TaskPage);
